<template>
  <b-row>
    <b-col class="container text-right">
      <b-button
        variant="primary"
        @click="onBtnAddClicked"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>เพิ่มข้อมูล</span>
      </b-button>
    </b-col>

    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter
              :mode="tab.mode"
              @handleSubmit="searchFilterSubmit"
              ref="searchFilterComponent"
            />
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
      <commonTable
        ref="tableCommon"
        :mode="tab"
        :rows="userList"
        @handle-select="onSelectChange"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import commonTable from "./components/detailTable.vue";
import SearchFilter from "./components/DetailSearchFilter.vue";
import ModalAddUser from "./components/ModalAddUser.vue";

import * as conclusionDetailStore from "@/store/api/conclusion/detail.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    ModalAddUser,
  },
  data() {
    return {
      tabs: [{ title: "รายการผลมติ", mode: "List" }],
      activeTab: ["List"],
      conclusionId: null,
    };
  },
  created() {
    //this.getCurrentRoleUser();
    if (this.$route.query.id === null) {
      window.open(this.$router.resolve({ name: 'Conclusion'}).href, '_blank');
    }
    this.conclusionId = this.$route.query.id
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    onBtnAddClicked() {
      window.open(this.$router.resolve({ name: 'ConclusionDetailManage', query : { conclusionId : this.conclusionId}}).href, '_blank');
    },
    
    searchFilterSubmit(params) {
      this.$refs.tableCommon[0].onSearchSubmit(params)
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
